// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"187":"9a6b38ea","342":"91f761c5","409":"a7d3540a","548":"0664828b","681":"d83c7d7a"}[chunkId] + ".chunk.js";
};